import { useMatch } from 'react-router-dom';
import styles from './HeaderIllustration.module.css';
const HeaderIllustration = ({
  url,
  imgSrc,
  bgColor,
}: {
  url?: string;
  imgSrc?: string;
  bgColor?: string | null;
}) => {
  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.style.display = 'none';
  };
  return (
    <div
      className={styles.illustrationWrapper}
      style={{ backgroundColor: bgColor ?? '' }}
    >
      {!!url && (
        <img src={url} alt='header illustration' onError={handleError} />
      )}
      {!!imgSrc && <img src={imgSrc} alt='header illustration' />}
    </div>
  );
};

export default HeaderIllustration;
